import React from 'react'
import MonitorCard from 'components/Dashboard/MonitorCard'
import TableComponent from 'components/common/TableComponent'
import { useTableData } from 'hooks/useTableData'

const AgroSection = ({ data, dates }) => {
  const {
    agroDataYesterday,
    agroDataToday,
    agroDataGroupsMonitorYesterday,
    agroDataGroupsMonitor,
    agroDataLast7Days,
    agroDataLast30Days
  } = data

  const agroActionsYesterdayTableData = useTableData(agroDataYesterday, 'agroActions')
  const agroActionsTodayTableData = useTableData(agroDataToday, 'agroActions')
  const agroGroupsTableData = useTableData(agroDataGroupsMonitorYesterday, 'agroGroups')
  const agroGroupsTodayTableData = useTableData(agroDataGroupsMonitor, 'agroGroups')
  const agroActionsLast7DaysTableData = useTableData(agroDataLast7Days, 'agroActions')
  const agroActionsLast30DaysTableData = useTableData(agroDataLast30Days, 'agroActions')

  return (
    <div className='grid grid-cols-1 lg:grid-cols-2 gap-4'>
      <div className='h-full'>
        <MonitorCard
          title='Resumen acciones agro'
          color='green'
          date={`Previous Agro Day (${dates.previousDate})`}
          hasData={agroActionsYesterdayTableData.rows.length > 0}
          showFilterBtn={false}
        >
          <div className='text-xs'>
            <TableComponent 
              tableData={agroActionsYesterdayTableData} 
              defaultSortColumn={agroActionsYesterdayTableData.columns[0]?.key} 
            />
          </div>
        </MonitorCard>
      </div>

      <div className='h-full'>
        <MonitorCard
          title='Resumen acciones agro'
          color='green'
          date={`Today (${dates.currentDate})`}
          hasData={agroActionsTodayTableData.rows.length > 0}
          showFilterBtn={false}
        >
          <div className='text-xs'>
            <TableComponent 
              tableData={agroActionsTodayTableData} 
              defaultSortColumn={agroActionsTodayTableData.columns[0]?.key} 
            />
          </div>
        </MonitorCard>
      </div>

      <div className='h-full'>
        <MonitorCard
          title='Monitoreo de grupos'
          color='green'
          date={`Previous Agro Day (${dates.previousDate})`}
          hasData={agroGroupsTableData.rows.length > 0}
          showFilterBtn={false}
        >
          <div className='text-xs'>
            <TableComponent 
              tableData={agroGroupsTableData} 
              defaultSortColumn={agroGroupsTableData.columns[0]?.key} 
            />
          </div>
        </MonitorCard>
      </div>

      <div className='h-full'>
        <MonitorCard
          title='Monitoreo de grupos'
          color='green'
          date={`Today (${dates.currentDate})`}
          hasData={agroGroupsTodayTableData.rows.length > 0}
          showFilterBtn={false}
        >
          <div className='text-xs'>
            <TableComponent 
              tableData={agroGroupsTodayTableData} 
              defaultSortColumn={agroGroupsTodayTableData.columns[0]?.key} 
            />
          </div>
        </MonitorCard>
      </div>

      <div className='h-full'>
        <MonitorCard
          title='Resumen acciones agro'
          color='green'
          date={`Last 7 Days (${dates.last7DaysRange})`}
          hasData={agroActionsLast7DaysTableData.rows.length > 0}
          showFilterBtn={false}
        >
          <div className='text-xs'>
            <TableComponent 
              tableData={agroActionsLast7DaysTableData} 
              defaultSortColumn={agroActionsLast7DaysTableData.columns[0]?.key} 
            />
          </div>
        </MonitorCard>
      </div>

      <div className='h-full'>
        <MonitorCard
          title='Resumen acciones agro'
          color='green'
          date={`Last 30 Days (${dates.last30DaysRange})`}
          hasData={agroActionsLast30DaysTableData.rows.length > 0}
          showFilterBtn={false}
        >
          <div className='text-xs'>
            <TableComponent 
              tableData={agroActionsLast30DaysTableData} 
              defaultSortColumn={agroActionsLast30DaysTableData.columns[0]?.key} 
            />
          </div>
        </MonitorCard>
      </div>
    </div>
  )
}

export default AgroSection